import React, { useState } from 'react';
import { Dropdown, DropdownToggle, DropdownMenu, DropdownItem, Spinner, Button, Badge, UncontrolledTooltip } from 'reactstrap';
import { useDispatch } from 'react-redux';
import * as actions from '../../store/actions';
import { toast } from 'react-toastify';
import Cookies from 'js-cookie';

const AdminRow = ({ admin }) => {
    if (!admin) {
        return null;
    }

    const [dropdownOpen, setDropdownOpen] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [showPassword, setShowPassword] = useState(false);
    const dispatch = useDispatch();

    const toggleDropdown = () => setDropdownOpen(!dropdownOpen);

    const confirmDelete = (adminId) => {
        const userId = Cookies.get("sessionId", {
            secure: true, 
            sameSite: 'None',
            path: "/"
        });
        if (adminId === userId) {
            toast.error('لا يمكن حذف حساب المستخدم الحالي.');
            return;
        }
        toast.warn(
            <div className='d-flex flex-column justify-content-center gap-2 align-items-center'>
                <p className="mb-2">هل أنت متأكد أنك تريد حذف هذا المدير؟</p>
                <div className="d-flex gap-2">
                    <Button 
                        color="danger" 
                        size="sm"
                        onClick={() => {
                            handleDelete(adminId);
                            toast.dismiss();
                        }}
                    >
                        نعم، احذف
                    </Button>
                    <Button 
                        color="secondary" 
                        size="sm"
                        onClick={() => toast.dismiss()}
                    >
                        إلغاء
                    </Button>
                </div>
            </div>,
            {
                position: "top-center",
                autoClose: false,
                closeOnClick: false,
                draggable: false,
            }
        );
    };

    const handleRoleChange = (newRole) => {
        if (admin.role === newRole) {
            toast.info('الدور المحدد هو نفسه الدور الحالي');
            return;
        }
        
        setIsLoading(true);
        dispatch(actions.changeAdminRoleRequest(admin.id, newRole));

        setTimeout(() => {
            toast.success('تم تغيير الدور بنجاح', {
                icon: "✅",
                position: "top-center"
            });
            setIsLoading(false);
        }, 20000);
    };

    const handleDelete = (adminId) => {
        dispatch(actions.deleteAdminRequest(adminId));
        toast.success('تم حذف المشرف بنجاح');
    };

    const getRoleBadge = (role) => {
        return role === 'super_admin' 
            ? <Badge color="primary" className="px-3 py-2">
                <i className="bx bx-crown me-1"></i>
                مشرف عام
              </Badge>
            : <Badge color="info" className="px-3 py-2">
                <i className="bx bx-user me-1"></i>
                مشرف
              </Badge>;
    };

    return (
        <tr className="align-middle">
            <td className="px-4 py-3">
                <div className="d-flex align-items-center">
                    <div className="avatar-xs me-3">
                        <span className={`avatar-title rounded-circle ${admin.role === 'super_admin' ? 'bg-primary-subtle text-primary' : 'bg-info-subtle text-info'} font-size-16`}>
                            <i className={`bx ${admin.role === 'super_admin' ? 'bx-crown' : 'bx-user'}`}></i>
                        </span>
                    </div>
                    <span className="fw-semibold">{admin.username || 'مشرف'}</span>
                </div>
            </td>
            <td className="py-3">
                <div className="d-flex align-items-center">
                    <i className="bx bx-envelope text-muted me-2"></i>
                    <span>{admin.email}</span>
                </div>
            </td>
            <td className="py-3">
                {getRoleBadge(admin.role)}
            </td>
            <td className="py-3 text-center">
                <Dropdown isOpen={dropdownOpen} toggle={toggleDropdown}>
                    <DropdownToggle 
                        color="light" 
                        className="btn-sm"
                        style={{ borderRadius: '8px' }}
                        disabled={isLoading}
                    >
                        {isLoading ? (
                            <Spinner size="sm" />
                        ) : (
                            <>
                                <i className="bx bx-refresh me-1"></i>
                                تغيير
                            </>
                        )}
                    </DropdownToggle>
                    <DropdownMenu end style={{ borderRadius: '8px' }}>
                        <DropdownItem 
                            onClick={() => handleRoleChange('admin')}
                            disabled={admin.role === 'admin'}
                        >
                            <i className="bx bx-user me-2"></i>
                            مشرف عادي
                        </DropdownItem>
                        <DropdownItem 
                            onClick={() => handleRoleChange('super_admin')}
                            disabled={admin.role === 'super_admin'}
                        >
                            <i className="bx bx-crown me-2"></i>
                            مشرف عام
                        </DropdownItem>
                    </DropdownMenu>
                </Dropdown>
            </td>
            <td className="py-3 text-center">
                <div className="d-flex align-items-center justify-content-center">
                    <span 
                        onClick={() => setShowPassword(!showPassword)} 
                        style={{ 
                            cursor: 'pointer',
                            fontFamily: 'monospace',
                            fontSize: '14px',
                            backgroundColor: '#f8f9fa',
                            padding: '6px 12px',
                            borderRadius: '6px',
                            border: '1px solid #e3e3e3'
                        }}
                        id={`password-${admin.id}`}
                    >
                        {showPassword ? admin.password : '••••••••'}
                        <i className={`bx ${showPassword ? 'bx-hide' : 'bx-show'} ms-2 text-muted`}></i>
                    </span>
                    <UncontrolledTooltip placement="top" target={`password-${admin.id}`}>
                        {showPassword ? 'إخفاء كلمة المرور' : 'عرض كلمة المرور'}
                    </UncontrolledTooltip>
                </div>
            </td>
        </tr>
    );
};

export default AdminRow;
